{
  "title": "Blast Rooms",
  "subtitle": "Pick a room, {{count}} rooms will explode",
  "tables": "Tables",
  "stageNine": "Nine-Light Village",
  "stageSix": "Six-Light Expedition",
  "tier": {
    "classic_9": "9-Room Classic",
    "high_risk_6": "6-Room High Risk"
  },
  "lobby": "Lobby",
  "backLobby": "Lobby",
  "connecting": "Connecting…",
  "connected": "Connected",
  "reconnecting": "Reconnecting…",
  "authFailed": "Login failed",
  "retryLogin": "Retry Connection",
  "unauthorized": "Please enter from the lobby",
  "balance": "Balance {{amount}}",
  "room": "{{id}}",
  "selectedRoom": "Room {{id}}",
  "players": "{{n}} players",
  "presence": "Seated {{seated}} · Watching {{watching}} · Total {{pot}}",
  "selectRoom": "Please select a room first",
  "bet": "Amount",
  "half": "1/2",
  "max": "Max",
  "quickChips": "Quick chips",
  "close": "Close",
  "placed": "Bet {{amount}}",
  "submittingBet": "Submitting Bet…",
  "switchingRoom": "Switching Room…",
  "connectionUnavailable": "Connection is not ready; betting is paused",
  "requestFailed": "Action was not completed. Check the connection and try again.",
  "balanceRefreshFailed": "Round completed; balance is temporarily unavailable",
  "settlementReconciliation": "Your previous payout still needs confirmation. Betting is locked while support reconciles it.",
  "settlementReconciliationRound": "The payout for round {{roundId}} was not credited and requires manual review. New bets are paused; contact support with this round ID.",
  "settlementNeedsReview": "Payout Review",
  "retryBalance": "Refresh Balance",
  "refreshingBalance": "Refreshing Balance…",
  "switchRoom": "Click another room to switch",
  "bettingLeft": "{{sec}}s",
  "bettingLive": "Betting, {{sec}} seconds remaining",
  "roomAvailable": "Available",
  "roomSelected": "Selected",
  "roomSafe": "Safe room",
  "roomExploded": "Exploded",
  "roomOdds": "Odds {{odds}}x",
  "roomOddsPending": "Odds loading",
  "youWin": "Win +{{payout}}",
  "youLose": "Loss −{{amount}}",
  "rules": "Rules",
  "rulesTitle": "How to Play Blast Rooms",
  "rulesBody": "Choose a shelter room and place your bet. When betting locks, a set number of rooms will detonate. Players in the surviving safe rooms share the round's payout according to room multipliers.",
  "phase": {
    "waiting": "Waiting",
    "betting": "Betting",
    "locked": "Locked",
    "revealing": "Exploding",
    "settled": "Settled"
  }
}
